
namespace RioERP.Products {

    @Serenity.Decorators.registerClass()
    export class PacksGrid extends Serenity.EntityGrid<PacksRow, any> {
        protected getColumnsKey() { return PacksColumns.columnsKey; }
        protected getDialogType() { return PacksDialog; }
        protected getIdProperty() { return PacksRow.idProperty; }
        protected getInsertPermission() { return PacksRow.insertPermission; }
        protected getLocalTextPrefix() { return PacksRow.localTextPrefix; }
        protected getService() { return PacksService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            buttons.push({
                title: 'Sync Packs',
                cssClass: 'add-button',
                separator: true,
                onClick: () => {
                    Q.confirm("Are you sure You want to Sync Packs?", () => {

                        PacksService.ListPacks({}, response => {
                            Q.notifySuccess("Packs Synced Successfully");
                            this.refresh();
                        });
                    });
                }
            });

            return buttons;
        }
    }
}